// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GiONPevLRY5Fi6 {
  display: flex;
  flex-direction: column;
  margin: 0;
}
.Faj1y6PjJVImcC {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.WeSdlvjnpajkLG {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 32px;
}
.XCegMDDmb_BAg_ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 240px;
  margin: 0;
}
.ozlXShbVvtSSuc {
  flex: 1 1 600px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GiONPevLRY5Fi6`,
	"title": `Faj1y6PjJVImcC`,
	"layout": `WeSdlvjnpajkLG`,
	"sidebar": `XCegMDDmb_BAg_`,
	"list": `ozlXShbVvtSSuc`
};
export default ___CSS_LOADER_EXPORT___;
